import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
	en: {
		projectName:'VidPush',
		auth: {
			login: 'Login',
			logout: 'Logout',
			email: 'Email',
			email_description: 'Used as a login for authorization',
			password: 'Password',
			passwordReset: 'Reset password',
			passwordReset_description: 'Create a password reset link and send an email',
			passwordReset_confirm: 'Do you really want to send a password reset link to the user?',
			demoAccount: 'Login/password: test@test.com 123456',
			requiredFields: 'Required fields',
		},
		user:{
			displayName:'Display name',
			displayName_description:'The user name that is displayed in the interface',
			isAdmin:'Administrative rights',
			isAdmin_description:'Administrator can create users on the system, manage their accounts, and view the content they upload',
			remove:'Remove user',
			remove_confirm:'Do you want to remove a user?',
		},
		files:{
			selectFileToUpload:'Select file to upload',
			chooseFile:'Choose a file...',
			dropFileHere:'Drop file here...',
			file:'File',
			video:'Video',
			icon:'Icon',
			title:'Title',
			description:'Description',
			play:'Play',
			empty:'You haven\'t uploaded any videos yet',
			myfiles:'My files',
			allfiles:'All files'
		},
		links:{
			home:'Home',
			test:'Test',
			profile:'Profile',
			files:'Files',
			manage:'Manage'
		},

		uploadNewFile:'Upload new file',
		uploadPageDesc:'This is the page to upload new files',
		userManagement:'User management',
		userManagementPageDesc:'The page where we will manage other accounts',
		userPageTitle:'User page',
		userList:'User list',
		createNewUser:'Create New User',
		authorizedUserInformation:'Information about the authorized user',
		cancel:'Сancel',
		create:'Create',
		update:'Update',
		upload:'Upload',
		uploading:'Uploading...',
		download:'Download',
		hide:'Hide',
		yes:'Yes',
		no:'No',
		сopied:'Copied',
		confirmDialogTitle:'Please Confirm',
		copyLinkToClipboard:'Copy link to clipboard',
	}
}

export default new VueI18n({
	locale: 'en',
	messages
})